<mat-card *ngIf="collaboratorList" style="padding: 0px;width:100%">
  <mat-toolbar style="font-weight:bold;width:100%"><h3 style="width:120px;margin-left:10px">{{ 'equipTreball.titol' | translate }}</h3>
    <button style="margin-left: 20px;width:60px; cursor:pointer" mat-icon-button (click)="openEditor()">
      <mat-icon matTooltip="{{ 'equipTreball.afegirToolTip' | translate }}" attr.aria-label="{{ 'equipTreball.afegirToolTip' | translate }}" matTooltipClass="tooltip-style" color="primary" style="font-size:24px">person_add</mat-icon>
    </button>
    <div style='float:left;clear:both;width:80%;padding:auto;font-weight:normal;font-size:0.8em' *ngIf="collaboratorList.length">
      <div style="float:left;clear:none;width:80%;text-align:center;">{{ 'equipTreball.colNom' | translate }}</div>
      <div style="float:left;clear:none;width:10%;text-align:center;word-wrap:break-word;hyphens:auto;">{{ 'equipTreball.colCoordinacio' | translate }}</div>
      <div style="float:left;clear:none;width:10%;text-align:center;word-wrap:break-word;hyphens:auto;">{{ 'equipTreball.colTecnic' | translate }}</div>      
    </div>
  </mat-toolbar>
  <mat-progress-bar mode="indeterminate" *ngIf="showAsyncProgress" style="position: absolute"></mat-progress-bar>
  <mat-card-content>
    <mat-list style="float:left;clear:both;width:100%">
      <mat-list-item *ngIf="!collaboratorList.length">
        {{ 'equipTreball.senseColaboradors' | translate }}
      </mat-list-item>

      <mat-list-item *ngFor="let collaborator of collaboratorList; let i = index;" style='float:left;clear:both;display:inline;width:100%'>
        <div style='float:left;clear:both;width:100%;padding:auto;margin:auto;border-bottom: 1px solid #EEEEEE;font-size: 1.0em'>
         <div style="float:left;clear:none;width:210px;margin-top:-10px">
          <button style="margin-right: 0;cursor:pointer;text-align: center" mat-icon-button (click)="updateCollaborator(collaborator, 'inactive')" matTooltip="{{ 'equipTreball.eliminarToolTip' | translate }}" attr.aria-label="{{ 'equipTreball.eliminarToolTip' | translate }}" matTooltipClass="tooltip-style">
            <mat-icon color="primary" style="font-size:24px">delete_forever</mat-icon>
          </button>
         </div>
         <div style='float:left;clear:none;width:80%;padding:auto;margin:auto'>
           <div style="float:left;clear:none;width:80%;text-align: center">&nbsp;{{collaborator.name}}</div>
           <div style="float:left;clear:none;width:10%;text-align: center"><mat-checkbox [(ngModel)]="collaborator.coordinador" title="{{ 'equipTreball.colCoordinacio' | translate }}" (click)="setCoordinador(collaborator.id)"></mat-checkbox></div>
           <div style="float:left;clear:none;width:10%;text-align: center"><mat-checkbox [(ngModel)]="collaborator.coord_tecnic" title="{{ 'equipTreball.colTecnic' | translate }}" (click)="setCoordinadorTecnic(collaborator.id)"></mat-checkbox></div>
          </div>
        </div>
      </mat-list-item>
    </mat-list>
    <div *ngIf="showEditor" style="float:left;clear:left;width: 85%;padding-top:20px;padding-left:20px;margin:auto">
        <mat-select placeholder="{{ 'equipTreball.codiPlaceholder' | translate }}" name="codi" style="width:60%" [(ngModel)]="newCollaboratorId" ngDefaultControl
         >
          <mat-option *ngFor="let collaborator of availableCollaborators" value="{{collaborator.id}}">{{collaborator.name}}</mat-option>
        </mat-select>
        <button style="margin-left:auto;margin-right:0;cursor:pointer" mat-icon-button (click)="addCollaborator()" matTooltip="{{ 'equipTreball.afegirToolTip' | translate }}" attr.aria-label="{{ 'equipTreball.afegirToolTip' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">add</mat-icon>
        </button>
        <!-- <button style="margin-right: 0; cursor:pointer" mat-icon-button  (click)="closeEditor()" matTooltip="Elimina'm" aria-label="Elimina'm" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">delete_forever</mat-icon>
        </button> -->
    </div>
  </mat-card-content>
</mat-card>
<datalist id="availableCollaborators">
  <option *ngFor="let collaborator of availableCollaborators" value="{{collaborator.id}}">{{collaborator.name}}</option>
</datalist>
<mat-card *ngIf="error" class="error" style="float:left;clear:both">
  <mat-card-title align="center">{{ 'equipTreball.errorTitol' | translate:{ status: error.status } }}</mat-card-title>
  <mat-card-subtitle align="center">{{error.statusText}}</mat-card-subtitle>
  <mat-card-content align="center">
    <p>{{error.msg}}</p>
  </mat-card-content>
</mat-card>
